import { round } from 'lodash';
import { renderMultiple } from './display-investment-multiple';
import { numberToPercentageString } from './number-to-percentage-string';

export function formatMultiple(value: number | null) {
  if (value === null) return '-';
  return renderMultiple(value);
}

export function formatIRR(value: number | null) {
  if (value === null) return '-';
  return numberToPercentageString(value, {
    forceDecimals: true,
    accuracy: 2,
  });
}

export function formatPct(value: number | null) {
  if (value === null) return '-';
  return `${round(value * 100, 2)}%`;
}
